(function () {
  var pp = document.querySelector('[data-on-pp]'); if (!pp) return;
  var CHAVE_FECHOU = 'on-pp-fechou', CHAVE_OK = 'on-pp-cadastrou', CINCO_DIAS = 5 * 24 * 3600 * 1000;
  function ler(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function gravar(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  var voltou = /[?&]customer_posted=true/.test(location.search) && ler('on-pp-enviando');
  if (!voltou) {
    if (ler(CHAVE_OK)) return;
    var f = parseInt(ler(CHAVE_FECHOU) || '0', 10); if (f && Date.now() - f < CINCO_DIAS) return;
  }
  var caixa = pp.querySelector('.on-pp__caixa'), celular = window.matchMedia('(max-width: 749px)'), relogio = null;
  function escala() { if (!celular.matches) { caixa.style.removeProperty('--on-pp-escala'); return; }
    var s = Math.min(1, (window.innerWidth - 32) / 450, (window.innerHeight - 20) / caixa.offsetHeight); caixa.style.setProperty('--on-pp-escala', s.toFixed(4)); }
  function abrir() { pp.hidden = false; escala(); }
  function fechar(marca) { pp.hidden = true; if (relogio) clearInterval(relogio); if (marca) gravar(CHAVE_FECHOU, String(Date.now())); }
  function passo2() {
    gravar(CHAVE_OK, '1'); try { localStorage.removeItem('on-pp-enviando'); } catch (e) {}
    pp.querySelector('[data-on-pp-passo="1"]').hidden = true; pp.querySelector('[data-on-pp-passo="2"]').hidden = false; abrir();
    var fim = Date.now() + 10 * 60 * 1000, m = pp.querySelector('[data-on-pp-min]'), s = pp.querySelector('[data-on-pp-seg]');
    function tique() { var r = Math.max(0, Math.round((fim - Date.now()) / 1000)); m.textContent = String(Math.floor(r / 60)).padStart(2, '0'); s.textContent = String(r % 60).padStart(2, '0'); if (!r) clearInterval(relogio); }
    tique(); relogio = setInterval(tique, 1000);
  }
  pp.querySelectorAll('[data-on-pp-fechar]').forEach(function (b) { b.addEventListener('click', function () { fechar(!ler(CHAVE_OK)); }); });
  pp.addEventListener('click', function (e) { if (!caixa.contains(e.target)) fechar(!ler(CHAVE_OK)); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pp.hidden) fechar(!ler(CHAVE_OK)); });
  pp.querySelector('[data-on-pp-comprar]').addEventListener('click', function () { if (celular.matches) location.href = pp.dataset.destino; else fechar(false); });
  window.addEventListener('resize', function () { if (!pp.hidden) escala(); });
  var form = pp.querySelector('.on-pp__form'), email = form.querySelector('input[type=email]');
  email.addEventListener('input', function () { email.classList.remove('on-erro'); });
  form.addEventListener('submit', function (e) {   /* envio normal da Shopify (passa pela checagem anti-robô dela); a página volta com customer_posted=true e abre o passo 2 */
    if (!email.checkValidity()) { e.preventDefault(); email.classList.add('on-erro'); email.reportValidity(); return; }
    gravar('on-pp-enviando', '1');
  });
  if (voltou) { passo2(); return; }
  setTimeout(abrir, 4000);
})();
